import { createBlocksModel } from '@wix/yoshi-flow-editor/blocks';

export default createBlocksModel({
  widgetName: 'Post Share Buttons',
  props: {},
  methods: {},
  events: {},
});
